import { useServices, useTranslation } from 'cng-web-lib'
import moment from 'moment-timezone'
import React, { useRef, useState } from 'react'
import { Box, Button, Chip, Tooltip } from '@material-ui/core'
import useOrgFilter from '../Common/hooks/useOrgFilter'
import { getStatusLabel, getSubStatusLabel, STATUS_COLOR, STATUS_CODES, STATUS_LABEL, SUB_STATUS_CODES, canUpdateFiling, canEditDraft } from '../Common/constants/billStatuses'
import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import Namespace from 'src/constants/locale/Namespace'
import MpciTable from '../Common/components/MpciTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import pathMap from 'src/paths/pathMap'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import MpciApiClient from '../Common/services/MpciApiClient'
import CancelBillDialog from '../Common/components/CancelBillDialog'
import TruncCell from '../Common/components/TruncCell'


function TablePage(props) {
  const { history, location, showNotification } = props
  const tableRef = useRef(null)
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation([Namespace.UI_COMPONENT, Namespace.UAE_MPCI])

  // Fetched here (for orgId → organisation name lookup in the datatable) and passed down
  // to MpciTable via the orgFilter prop so it doesn't fetch the same org list a second time.
  const orgFilter = useOrgFilter()
  const { orgList } = orgFilter

  const [confirmDialog, setConfirmDialog] = useState({ open: false, bill: null })
  const [cancelDialog, setCancelDialog] = useState({ open: false, bill: null })
  const [cancelling, setCancelling] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const [bulkDeleteDialog, setBulkDeleteDialog] = useState(false)
  const [bulkSubmitDialog, setBulkSubmitDialog] = useState(false)

    const billNo = translate(Namespace.UAE_MPCI, UaeMpciKeys.BILL_NO)
  const parentBillNo = translate(Namespace.UAE_MPCI, UaeMpciKeys.PARENT_BILL_NO)
  const status = translate(Namespace.UAE_MPCI, UaeMpciKeys.STATUS)
  const createdDate = translate(Namespace.UAE_MPCI, UaeMpciKeys.CREATED_DATE)
  const submittedDate = translate(Namespace.UAE_MPCI, UaeMpciKeys.SUBMITTED_DATE)
  const editButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.EDIT_BUTTON)
  const deleteButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.DELETE_BUTTON)
  const createButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.CREATE_HOUSE_BILL_BUTTON)
  const cloneButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.CLONE_BUTTON)
  const updateButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.UPDATE_BUTTON)
  const deleteWarningMessage = translate(Namespace.UAE_MPCI, UaeMpciKeys.DELETE_WARNING_MESSAGE)
  const okDeleteButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.OK_DELETE_BUTTON)
  const cancelDeleteButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.CANCEL_DELETE_BUTTON)

  function handleCancelBill(cancellationReason) {
    if (cancelDialog.bill) {
      setCancelling(true)
            securedSendRequest.execute(
        'POST',
        UaeMpciApiUrls.HOUSE_BILL_CANCEL,
        { id: cancelDialog.bill.id, cancellationReason },
        (response) => {
          setCancelling(false)
          showNotification('success', 'Cancellation request sent.')
          setCancelDialog({ open: false, bill: null })
          if (tableRef.current) tableRef.current.performRefresh()
        },
        (error) => {
          setCancelling(false)
          console.log(error)
          showNotification('error', 'Cancel failed. Please try again.')
        },
        () => {},
        {},
        null
      )
    }
  }

    function handleDeleteBill() {
    if (confirmDialog.bill) {
      MpciApiClient.del(
        `${UaeMpciApiUrls.HOUSE_BILL_DELETE}/${confirmDialog.bill.id}`,
        {},
        () => {
                              showNotification('success', 'Delete succeeded')
          setConfirmDialog({ open: false, bill: null })
          if (tableRef.current) tableRef.current.performRefresh()
        },
        (error) => {
          console.log(error)
          showNotification('error', 'Delete failed')
        }
      )
    }
  }

  function handleBulkDelete() {
    const ids = selectedRows.map((r) => r.id)
    console.log('[HouseBill] bulk delete ids:', ids)
    MpciApiClient.post(
      UaeMpciApiUrls.HOUSE_BILL_DELETE_MULTIPLE,
      { ids },
      () => {
        showNotification(
          'success',
          `${ids.length} draft(s) successfully deleted`
        )
        setBulkDeleteDialog(false)
        setSelectedRows([])
        if (tableRef.current) tableRef.current.performRefresh()
      },
      (error) => {
        console.error('[HouseBill] bulk delete error', error)
        showNotification('error', 'Error encountered deleting selected draft(s)')
      }
    )
  }

  function handleBulkSubmit() {
    const ids = selectedRows.map((r) => r.id)
    console.log('[HouseBill] bulk submit ids:', ids)
    MpciApiClient.post(
      UaeMpciApiUrls.HOUSE_BILL_SUBMIT_MULTIPLE,
      { ids },
      () => {
        showNotification(
          'success',
          `${ids.length} draft(s) submitted successfully`
        )
        setBulkSubmitDialog(false)
        setSelectedRows([])
        if (tableRef.current) tableRef.current.performRefresh()
      },
      (error) => {
        console.error('[HouseBill] bulk submit error', error)
        showNotification('error', 'Error encountered submitting selected draft(s)')
      }
    )
  }

        const columns = [
    {
      field: 'id',
      title: 'System ID',
      render: (row) => <TruncCell value={row.id} />
    },
    {
      field: 'orgId',
      title: 'Organisation Name',
      render: (row) => {
        if (!row.orgId) return '—'
        const match = orgList.find((o) => o.id === row.orgId)
        return match ? match.name : '—'
      }
    },
        { field: 'userName',       title: 'User ID',      render: (row) => <TruncCell value={row.userName} /> },
    { field: 'mpciDocId',    title: 'MPCI Document ID/Transaction ID', render: (row) => <TruncCell value={row.mpciDocId} maxLength={20} /> },
    { field: 'masterBillNo', title: 'Master Bill No.', render: (row) => <TruncCell value={row.masterBillNo} maxLength={20} /> },
    { field: 'houseBillNo',  title: 'House Bill No.',  render: (row) => <TruncCell value={row.houseBillNo} maxLength={20} /> },
        { field: 'eta', title: 'ETA',
      render: (row) => row.eta
        ? <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{moment(row.eta).format('D MMM YYYY, HH:mm')}</span>
        : '—'
    },
        {
      field: 'status',
      title: 'Status',
      render: (row) => {
        const color = STATUS_COLOR[row.status] || { bg: '#f5f5f5', text: '#616161' }
        const subLabel = row.subStatus ? getSubStatusLabel(row.subStatus) : null
        const chipLabel = subLabel ? `${getStatusLabel(row.status)} (${subLabel})` : getStatusLabel(row.status)
        return (
          <Chip
            label={chipLabel}
            size='small'
            style={{
              background: color.bg,
              color: color.text,
              fontWeight: 600,
              fontSize: 11,
              height: 22,
              border: `1px solid ${color.text}22`
            }}
          />
        )
      }
    },
        {
      field: 'createdDate',
      title: 'Created Date',
      render: (row) => row.createdDate ? <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{moment(row.createdDate).format('D MMM YYYY, HH:mm')}</span> : '—'
    },
        {
      field: 'submittedDate',
      title: 'Submitted Date',
      render: (row) => row.submittedDate ? <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{moment(row.submittedDate).format('D MMM YYYY, HH:mm')}</span> : '—'
    },
        {
      field: 'responseDate',
      title: 'Response Date',
      render: (row) => row.responseDate ? <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{moment(row.responseDate).format('D MMM YYYY, HH:mm')}</span> : '—'
    }
  ]

    const statusOptions = Object.entries(STATUS_LABEL).map(([value, label]) => ({ value, label }))

      const orgOptions = orgList.map((o) => ({ value: o.id, label: o.name }))

  const filters = [
    { name: 'id',            label: 'System ID',    type: 'text' },
    { name: 'orgId',         label: 'Organisation', type: 'multiselect', options: orgOptions, searchable: true },
    { name: 'userName',        label: 'User ID',      type: 'text' },
    { name: 'mpciDocId',     label: 'MPCI Document ID/Transaction ID', type: 'text' },
    { name: 'masterBillNo',  label: parentBillNo,   type: 'text' },
    { name: 'houseBillNo',   label: billNo,         type: 'text' },
    { name: 'eta',           label: 'ETA',          type: 'daterange' },
    { name: 'status',        label: status,         type: 'multiselect', options: statusOptions },
    { name: 'createdDate',   label: createdDate,    type: 'daterange' },
    { name: 'submittedDate', label: submittedDate,  type: 'daterange' },
    { name: 'responseDate',  label: 'Response Date', type: 'daterange' }
  ]

    return (
    <>
      {/* Bulk Action Toolbar */}
      {selectedRows.length > 0 && (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-between'
          px={2}
          py={1}
          mb={1}
          style={{ background: '#e3f2fd', borderRadius: 6, border: '1px solid #90caf9' }}
        >
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            {selectedRows.length} record(s) selected
          </span>
          <Box display='flex' style={{ gap: 8 }}>
            <Button
              variant='contained'
              color='primary'
              size='small'
              onClick={() => setBulkSubmitDialog(true)}
            >
              Submit to NAIC
            </Button>
            {selectedRows.every((r) => r.status === STATUS_CODES.DRAFT) && (
              <Button
                variant='outlined'
                color='secondary'
                size='small'
                onClick={() => setBulkDeleteDialog(true)}
              >
                Delete
              </Button>
            )}
            <Button
              variant='outlined'
              size='small'
              onClick={() => {
                setSelectedRows([])
                if (tableRef.current) tableRef.current.clearSelection()
              }}
            >
              Clear Selection
            </Button>
          </Box>
        </Box>
      )}
      <MpciTable
        url={UaeMpciApiUrls.HOUSE_BILL_LIST}
        columns={columns}
        filters={filters}
        showOrgDropdown={false}
        orgFilter={orgFilter}
        retainStateKey='house-bill'
        history={history}
        actions={[
          {
            component: () => (
              <Button
                color='primary'
                variant='contained'
                size='medium'
                startIcon={<FontAwesomeIcon icon={['fal', 'plus-circle']} />}
                onClick={() => history.push(pathMap.UAE_MPCI_HOUSE_BILL_ADD_VIEW)}
              >
                                New House Bill
              </Button>
            )
          }
        ]}
                rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'arrow-up-from-bracket']} />,
            label: 'Update',
            onClick: (row) => history.push(`${pathMap.UAE_MPCI_HOUSE_BILL}/edit/${row.id}`),
            hidden: (row) => !canUpdateFiling(row.status, row.subStatus)
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'ban']} />,
            label: 'Cancel',
            onClick: (row) => setCancelDialog({ open: true, bill: row }),
            hidden: (row) => !canUpdateFiling(row.status, row.subStatus)
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: 'Edit Draft',
            onClick: (row) => history.push(`${pathMap.UAE_MPCI_HOUSE_BILL}/edit/${row.id}`),
            hidden: (row) => !canEditDraft(row.status, row.subStatus)
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: 'Clone as Draft',
            onClick: (row) => history.push(`${pathMap.UAE_MPCI_HOUSE_BILL_ADD_VIEW}?cloneId=${row.id}`)
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: 'Delete',
            onClick: (row) => setConfirmDialog({ open: true, bill: row }),
            hidden: (row) => {
              if (row.status === STATUS_CODES.SUBM_ERR) {
                return row.subStatus !== SUB_STATUS_CODES.FD
              }
              return row.status !== STATUS_CODES.DRAFT
            }
          }
        ]}
        selectionConfig={{
          isSelectable: (row) => [STATUS_CODES.DRAFT, STATUS_CODES.UPDATE_DRAFT].includes(row.status),
          disabledTooltip: 'Only draft records (including Updated filing draft) can be selected',
          onSelectionChange: (rows) => setSelectedRows(rows)
        }}
        onRowClick={(row) => {
          const isDraft = [STATUS_CODES.DRAFT, STATUS_CODES.UPDATE_DRAFT].includes(row.status)
          history.push(isDraft ? `${pathMap.UAE_MPCI_HOUSE_BILL}/edit/${row.id}` : `${pathMap.UAE_MPCI_HOUSE_BILL}/view/${row.id}`)
        }}
                  defaultSort={{ field: 'createdDate', direction: 'DESC' }}
          ref={tableRef}
        />
            <ConfirmDialog
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() => setConfirmDialog({ open: false, bill: null })}
        confirmDialog={handleDeleteBill}
        content={deleteWarningMessage}
        okMsg={okDeleteButton}
        cancelMsg={cancelDeleteButton}
        title={deleteButton}
      />
      <CancelBillDialog
        open={cancelDialog.open}
        bill={cancelDialog.bill}
        billType='HOUSE'
        onClose={() => setCancelDialog({ open: false, bill: null })}
        onSubmit={handleCancelBill}
        submitting={cancelling}
      />
     {/* Bulk Delete Confirmation */}
     <ConfirmDialog
       isConfirmDialogOpen={bulkDeleteDialog}
       closeDialog={() => setBulkDeleteDialog(false)}
       confirmDialog={handleBulkDelete}
       content={`Are you sure you want to delete ${selectedRows.length} selected draft(s)?`}
       okMsg='Delete'
       cancelMsg='Cancel'
       title='Bulk Delete'
     />

     {/* Bulk Submit Confirmation */}
     <ConfirmDialog
       isConfirmDialogOpen={bulkSubmitDialog}
       closeDialog={() => setBulkSubmitDialog(false)}
       confirmDialog={handleBulkSubmit}
       content={`Are you sure you want to submit ${selectedRows.length} draft(s) to NAIC?`}
       okMsg='Submit'
       cancelMsg='Cancel'
       title='Submit to NAIC'
     />
    </>
  )
}

export default TablePage